import { get, post, del } from './API';

export default {
  fetchExperienceGroups: async () => get('/experience-groups'),
  fetchExperienceGroupsWithExperiences: async () => get('/experience-groups', { include_experiences: true }),
  fetchFeaturedExperienceGroups: async () => get('/experience-groups', { featured: true }),
  fetchExperienceGroupById: async (id, includeExperiences = false) => get('/experience-groups', {
    id,
    include_experiences: includeExperiences,
  }),
  createExperienceGroup: async (group) => post('/experience-groups', group),
  updateExperienceGroup: async (group) => post('/experience-groups', group),
  deleteExperienceGroup: async (id) => del('/experience-groups', { id }),
  uploadExperienceGroupImage: async (groupId, imageData, contentType) => post('/experience-groups', {
    action: 'upload_image',
    group_id: groupId,
    image_data: imageData,
    content_type: contentType,
  }),
  removeExperienceGroupImage: async (groupId) => post('/experience-groups', {
    action: 'remove_image',
    group_id: groupId,
  }),
};
